module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ack-head"
  }, [_c('b', [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("So many people in my life have been supportive during my needlework journey, but none more than my mother, Doris, who put a needle in my hand when I was only a small girl and became my most devoted fan.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("Big hugs for my husband, Frank, who hand dyed wool, made countless trips to the post office and airport, and never complained when the dining room looked more like a quilt studio.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("My dear friend Helene cheerfully traveled with me to classes, shop hops, quilt shows, and embroidery seminars, sharing the fabrics and threads and always making it more fun.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("I am grateful to my amazingly supportive sisters, Cindy, Carol, Janet, and Robin, who have oohed and aahed at every showing of my work since I was a teenager.")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("I must also recognize my lifelong friend and colleague Mari. Mari’s encouragement and support was unwavering as she held the fort at Gemini Studio. Many thanks!")]), _vm._v(" "), _c('p', {
    staticClass: "ack"
  }, [_vm._v("I also wish to thank all my pilot students for reading directions, making excellent suggestions, and helping me become a better instructor.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-070cf127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_acknowledgments.vue
// module id = 66
// module chunks = 0